import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TechnicalDatasheet} from '@domain/technical-datasheet/technical-datasheet';
import {IPageInfo} from '@iharbeck/ngx-virtual-scroller';
import {isEqual, size} from 'lodash-es';

@Component({
  selector: 'app-technical-datasheet-list',
  templateUrl: './technical-datasheet-list.component.html',
  styleUrls: ['./technical-datasheet-list.component.scss']
})
export class TechnicalDatasheetListComponent {
  @Input() public listOfTechnicalDatasheets: TechnicalDatasheet[] = [];
  @Input() public selectedTechnicalDatasheet: TechnicalDatasheet;
  @Output() public virtualScrollerEnd: EventEmitter<void> = new EventEmitter<void>();
  @Output() public selectedTechnicalDatasheetChange: EventEmitter<TechnicalDatasheet> = new EventEmitter<TechnicalDatasheet>();

  public onVirtualScrollerEndEvent(pageInfo: IPageInfo): void {
    if (isEqual(pageInfo.endIndex, size(this.listOfTechnicalDatasheets) - 1)) {
      this.virtualScrollerEnd.emit();
    }
  }

  public selectTechnicalDatasheet(technicalDatasheet: TechnicalDatasheet): void {
    this.selectedTechnicalDatasheetChange.emit(this.isTechnicalDatasheetSelected(technicalDatasheet) ? null : technicalDatasheet);
  }

  public isTechnicalDatasheetSelected(technicalDatasheet: TechnicalDatasheet): boolean {
    return isEqual(technicalDatasheet.id, this.selectedTechnicalDatasheet?.id);
  }
}
